import { render } from "./PokemonPage.vue?vue&type=template&id=3daf70ef&scoped=true"
import script from "./PokemonPage.vue?vue&type=script&lang=js"
export * from "./PokemonPage.vue?vue&type=script&lang=js"

import "./PokemonPage.vue?vue&type=style&index=0&id=3daf70ef&scoped=true&lang=css"

import exportComponent from "E:\\Jose Carlos\\Escritorio\\Vue\\05-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3daf70ef"]])

export default __exports__